import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Navigate, useLocation } from 'react-router-dom';
import { auth } from '../../../../firebase.init';
import { toast } from 'react-toastify';
import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

const RequireAuth = ({ children }) => {
    const location = useLocation();
    const [user, loading, error] = useAuthState(auth);

    if (loading) {
        // toast.info('Checking authentication...', {
        //     toastId: 'auth-check'
        // });
        return;
    }

    if (!user) {
        toast.info('You need to log in to access this page.',
            {
                toastId: 'not-authenticated',
                icon: <FontAwesomeIcon icon={faCircleInfo} bounce size="sm" style={{ color: "red", }} />,
                progressClassName: 'red-progress-bar',
            });
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default RequireAuth;
